export const ticketsRoutes = {
  list: "",
  details: ":id",
} as const;

export type TicketsRouteParams = {
  list: {
    tab?: string;
    search?: string;
    sort?: string;
    assigneeIds?: string;
    assigneeMode?: string;
    ratings?: string;
    statusIds?: string;
    categoryIds?: string;
    visibility?: string;
    addressTypes?: string;
    isUnreadOnly?: string;
    closedFrom?: string;
    closedTo?: string;
    ratedFrom?: string;
    ratedTo?: string;
  };
};
